import React from 'react';
import PropTypes from 'prop-types';

function WritingPageIcon({ color = 'black', width = 25, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3333 0.333008C20.9773 0.333008 21.5 0.855675 21.5 1.49967V5.88284L19.1667 8.21618V2.66634H2.83333V21.333H19.1667V18.1153L21.5 15.782V22.4997C21.5 23.1437 20.9773 23.6663 20.3333 23.6663H1.66667C1.02267 23.6663 0.5 23.1437 0.5 22.4997V1.49967C0.5 0.855675 1.02267 0.333008 1.66667 0.333008H20.3333ZM22.4077 8.27567L24.0573 9.92534L14.983 18.9997L13.331 18.9973L13.3333 17.35L22.4077 8.27567ZM12.1667 11.9997V14.333H6.33333V11.9997H12.1667ZM15.6667 7.33301V9.66634H6.33333V7.33301H15.6667Z"
        fill={color}
      />
    </svg>
  );
}

WritingPageIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default WritingPageIcon;
